export const isTheSameDay = (
  first: Date | null | undefined,
  second: Date | null | undefined
) => {
  return (
    first?.getFullYear() == second?.getFullYear() &&
    first?.getMonth() == second?.getMonth() &&
    first?.getDate() == second?.getDate()
  )
}
